/* eslint-disable */
import { FuseNavigationItem } from "@fuse/components/navigation";

export const defaultNavigation: FuseNavigationItem[] = [
  {
    id: "dashboard",
    title: "Dashboard",
    type: "basic",
    icon: "heroicons_outline:chart-bar",
    link: "/dashboard",
  },
  {
    id: "reservations",
    title: "Reservas",
    type: "basic",
    icon: "heroicons_outline:clipboard-document-list",
    link: "/reservations",
  },
  {
    id: "report",
    title: "Estado de Cuenta",
    type: "basic",
    icon: "heroicons_outline:chart-pie",
    link: "/report",
  },
  {
    id: "help",
    title: "Ayuda",
    type: "basic",
    icon: "heroicons_outline:academic-cap",
    link: "/ayuda",
  },
  {
    id: "faqs",
    title: "Preguntas Frecuentes",
    type: "basic",
    icon: "heroicons_outline:question-mark-circle",
    link: "/faqs",
  },
  {
    id: "settings",
    title: "Configuración",
    type: "basic",
    icon: "heroicons_outline:cog-6-tooth",
    link: "/settings",
  },
  {
    id: "platform",
    title: "Plataforma",
    type: "basic",
    icon: "heroicons_outline:chart-bar-square",
    link: "/platform",
  },
];
export const compactNavigation: FuseNavigationItem[] = [
  {
    id: "dashboard",
    title: "Dashboard",
    type: "basic",
    icon: "heroicons_outline:chart-bar",
    link: "/dashboard",
  },
  {
    id: "reservations",
    title: "Reservas",
    type: "basic",
    icon: "heroicons_outline:clipboard-document-list",
    link: "/reservations",
  },
  {
    id: "report",
    title: "Estado de Cuenta",
    type: "basic",
    icon: "heroicons_outline:chart-pie",
    link: "/report",
  },
  {
    id: "help",
    title: "Ayuda",
    type: "basic",
    icon: "heroicons_outline:academic-cap",
    link: "/ayuda",
  },
  {
    id: "faqs",
    title: "Preguntas Frecuentes",
    type: "basic",
    icon: "heroicons_outline:question-mark-circle",
    link: "/faqs",
  },
  {
    id: "settings",
    title: "Configuración",
    type: "basic",
    icon: "heroicons_outline:cog-6-tooth",
    link: "/settings",
  },
  {
    id: "platform",
    title: "Plataforma",
    type: "basic",
    icon: "heroicons_outline:chart-bar-square",
    link: "/platform",
  },
];
export const futuristicNavigation: FuseNavigationItem[] = [
  {
    id: "dashboard",
    title: "Dashboard",
    type: "basic",
    icon: "heroicons_outline:chart-bar",
    link: "/dashboard",
  },
  {
    id: "reservations",
    title: "Reservas",
    type: "basic",
    icon: "heroicons_outline:clipboard-document-list",
    link: "/reservations",
  },
  {
    id: "report",
    title: "Estado de Cuenta",
    type: "basic",
    icon: "heroicons_outline:chart-pie",
    link: "/report",
  },
  {
    id: "help",
    title: "Ayuda",
    type: "basic",
    icon: "heroicons_outline:academic-cap",
    link: "/ayuda",
  },
  {
    id: "faqs",
    title: "Preguntas Frecuentes",
    type: "basic",
    icon: "heroicons_outline:question-mark-circle",
    link: "/faqs",
  },
  {
    id: "settings",
    title: "Configuración",
    type: "basic",
    icon: "heroicons_outline:cog-6-tooth",
    link: "/settings",
  },
  {
    id: "platform",
    title: "Plataforma",
    type: "basic",
    icon: "heroicons_outline:chart-bar-square",
    link: "/platform",
  },
];
export const horizontalNavigation: FuseNavigationItem[] = [
  {
    id: "dashboard",
    title: "Dashboard",
    type: "basic",
    icon: "heroicons_outline:chart-bar",
    link: "/dashboard",
  },
  {
    id: "reservations",
    title: "Reservas",
    type: "basic",
    icon: "heroicons_outline:clipboard-document-list",
    link: "/reservations",
  },
  {
    id: "report",
    title: "Estado de Cuenta",
    type: "basic",
    icon: "heroicons_outline:chart-pie",
    link: "/report",
  },
  {
    id: "help",
    title: "Ayuda",
    type: "basic",
    icon: "heroicons_outline:academic-cap",
    link: "/ayuda",
  },
  {
    id: "faqs",
    title: "Preguntas Frecuentes",
    type: "basic",
    icon: "heroicons_outline:question-mark-circle",
    link: "/faqs",
  },
  {
    id: "settings",
    title: "Configuración",
    type: "basic",
    icon: "heroicons_outline:cog-6-tooth",
    link: "/settings",
  },
  {
    id: "platform",
    title: "Plataforma",
    type: "basic",
    icon: "heroicons_outline:chart-bar-square",
    link: "/platform",
  },
];
